import React, { useCallback, useEffect, useState } from 'react';
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import * as CryptoJS from "crypto-js";
import { Box, Pagination } from '@mui/material';
import Select from "react-select";
import { Parser } from "json2csv";
import FromFieldDate from "../../../atoms/FromFieldDate";
import { getNotAllcatedData, getNotAllocatedCSV, getNotAllocatedLogCSV } from '../../../services/asset.service';
import { getDivisionAdditionalList } from '../../../services/user.service';

/* ─── Import same CSS as AssetList ─── */
import '../../ExcelUploads/AssetInfo/AssetInfo.css';
import '../../ExcelUploads/AssetInfo/AssetList.css';

/* ─── Date Helpers ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
};

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

/* ─── Columns ─── */
const columns = [
    { field: "sl_no", hideable: true, hide: true, headerName: "Sl No", width: 50 },
    {
        field: 'tag', editable: false, hide: false, headerName: 'TAG', width: 250,
        renderCell: (params) => {
            let encryptedTag = CryptoJS.AES.encrypt(JSON.stringify({
                'tag': params.row.tag,
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            return <a className="al-cell-tag-link" href={`/single-view-allocation?tag=${encryptedTag}`}>{params.row.tag}</a>;
        }
    },
    {
        field: 'actions', headerName: 'Actions', width: 100,
        renderCell: (params) => {
            let EncryptTag = CryptoJS.AES.encrypt(JSON.stringify({
                'tag': params.row.tag,
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            return (
                <span>
                    <a title='Allocate' href={`/single-allocation?tag=${EncryptTag}&allocate=true`} className="btn btn-primary btn-sm">
                        <i className='bi bi-check-circle-fill' />
                    </a>{' '}
                    <a title='View Log' href={`/allocation-log?tag=${EncryptTag}`} className="btn btn-info btn-sm">
                        <i className='bi bi-eye-fill' />
                    </a>
                </span>
            );
        }
    },
    { field: "division", hideable: true, hide: true, headerName: "Division", width: 130 },
    { field: "allocation_status", hide: false, headerName: "Allocation Status", width: 160 },
    {
        field: "allocate_tag", hide: false, headerName: "Allocated", width: 130,
        renderCell: (params) => <p>{(params.row.allocate_tag == null) ? 'New Free' : 'Free'}</p>
    },
    {
        field: "created_at", hide: false, headerName: "Created Date", width: 130,
        renderCell: (params) => <p>{getFormatedDate(params.row.created_at)}</p>
    },
    { field: "status", hide: true, headerName: "Status", width: 130 },
];

const CustomLoader = () => (
    <GridOverlay>
        <CircularProgress color="primary" size={30} />
    </GridOverlay>
);

const NonAllocated = () => {
    const [items, setItems] = useState([]);
    const [itemsCSV, setItemsCSV] = useState([]);
    const [searchTag, setSearchTag] = useState('');
    const [ErrSearchTag, setErrSearchTag] = useState(false);
    const [loading, setLoading] = useState(true);
    const [exloading, setExLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [filterCriteria, setFilterCriteria] = useState('');
    const [ErrFilterCriteria, setErrFilterCriteria] = useState(false);
    const [filterOperator, setFilterOperator] = useState('');
    const [ErrFilterOperator, setErrFilterOperator] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [ErrStartDate, setErrStartDate] = useState(false);
    const [endDate, setEndDate] = useState('');
    const [ErrEndDate, setErrEndDate] = useState(false);
    const [hasData, setHasData] = useState(false);
    const [otherDivisions, setOtherDivisions] = useState([]);
    const [selectedOtherDivisions, setSelectedOtherDivisions] = useState([]);

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

    /* ─── Fetch (no filters) ─── */
    const fetchAssets = useCallback(async (currentPage = page, currentPageSize = pageSize) => {
        setLoading(true);
        const offset = calculateOffset(currentPage, currentPageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: { 'offset': offset, 'pageSize': currentPageSize },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const res = await getNotAllcatedData({ token: encryptedData });
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems([]);
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    /* ─── Fetch (with filters) ─── */
    const fetchAssets1 = async (currentPage = page, currentPageSize = pageSize) => {
        setLoading(true);
        const offset = calculateOffset(currentPage, currentPageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'offset': offset,
                'pageSize': currentPageSize,
                'searchTag': searchTag,
                'filterCriteria': filterCriteria,
                'filterOperator': filterOperator,
                'startDate': startDate,
                'endDate': endDate,
                'other_division': otherDivisionIds,
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const res = await getNotAllcatedData({ token: encryptedData });
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems([]);
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    };

    /* ─── Effects ─── */
    useEffect(() => { fetchAssets(page, pageSize); }, []);

    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: { 'other_division_ids': sessionStorage.getItem('LoggedInOtherDivisionIds') },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        getDivisionAdditionalList({ 'token': EncryptData }).then(res => {
            if (res?.data?.data?.length) setOtherDivisions(res.data.data);
        });
    }, []);

    /* ─── Pagination ─── */
    const totalPages = Math.ceil(totalItems / pageSize);

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
        if (filterCriteria) fetchAssets1(1, value);
        else fetchAssets(1, value);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
        if (filterCriteria) fetchAssets1(value, pageSize);
        else fetchAssets(value, pageSize);
    };

    const [exLogLoading, setExLogLoading] = useState(false);

    /* ─── Export without Log ─── */
    const handleExportWithoutLog = async () => {
        setExLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'offset': offset,
                'pageSize': pageSize,
                'searchTag': searchTag,
                'filterCriteria': filterCriteria,
                'filterOperator': filterOperator,
                'startDate': getFormatedDate(startDate),
                'endDate': getFormatedDate(endDate),
                'other_division': otherDivisionIds,
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const resCSV = await getNotAllocatedCSV({ token: encryptedData });
            if (resCSV?.data?.data?.length) {
                generateCSVWithoutLog(resCSV.data.data);
            }
        } catch (error) {
            console.error('Error exporting data without log:', error);
        } finally {
            setExLoading(false);
        }
    };

    /* ─── Export with Log ─── */
    const handleExportWithLog = async () => {
        setExLogLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'offset': offset,
                'pageSize': pageSize,
                'searchTag': searchTag,
                'filterCriteria': filterCriteria,
                'filterOperator': filterOperator,
                'startDate': getFormatedDate(startDate),
                'endDate': getFormatedDate(endDate),
                'other_division': otherDivisionIds,
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const resCSV = await getNotAllocatedLogCSV({ token: encryptedData });
            if (resCSV?.data?.data?.length) {
                generateCSVWithLog(resCSV.data.data);
            }
        } catch (error) {
            console.error('Error exporting data with log:', error);
        } finally {
            setExLogLoading(false);
        }
    };

    const generateCSVWithoutLog = (csvData) => {
        try {
            const jsonData = csvData.map(item => ({
                tag: item.tag || '',
                division: item.division || '',
                allocation_status: 'Not Allocated',
                allocate_tag: item.allocate_tag == null ? 'New Free' : 'Free',
                created_at: item.created_at ? getFormatedDate(item.created_at) : '',
            }));
            const json2csvParser = new Parser();
            const csv = json2csvParser.parse(jsonData);
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Not_Allocated_List_Without_Log.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data to CSV:', error);
        }
    };

    const generateCSVWithLog = (csvData) => {
        try {
            const jsonData = csvData.map(item => ({
                tag: item.tag || '',
                ain_no: item.ain_no || '',
                division: item.division || '',
                premises: item.premises || '',
                floor: item.floor || '',
                site_id: item.site_id || '',
                user_type: item.user_type || '',
                user_department: item.user_department || '',
                employee_id: item.employee_id || '',
                employee_name: item.employee_name || '',
                user_mail_id: item.user_mail_id || '',
                effective_date: item.effective_date ? getFormatedDate(item.effective_date) : '',
                unallocate_date: item.unallocate_date ? getFormatedDate(item.unallocate_date) : '',
                reason: item.reason || '',
                batch_id: item.batch_id || '',
                created_at: item.created_at ? getFormatedDate(item.created_at) : '',
            }));
            const json2csvParser = new Parser();
            const csv = json2csvParser.parse(jsonData);
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Not_Allocated_List_With_Log.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data with log:', error);
        }
    };

    /* ─── Search / Filter ─── */
    const handleSearch = () => {
        let isValid = true;
        if (!filterCriteria) { setErrFilterCriteria('Please select a filter criteria'); isValid = false; } else setErrFilterCriteria('');
        if (filterCriteria !== 'created_at' && !filterOperator) { setErrFilterOperator('Please select a filter operator'); isValid = false; } else setErrFilterOperator('');
        if (!searchTag && filterCriteria !== 'created_at') { setErrSearchTag('Please enter a search text'); isValid = false; } else setErrSearchTag('');
        if (!startDate && filterCriteria === 'created_at') { setErrStartDate('Please select start date'); isValid = false; } else setErrStartDate('');
        if (!endDate && filterCriteria === 'created_at') { setErrEndDate('Please select end date'); isValid = false; } else setErrEndDate('');
        if (isValid) { setPage(1); fetchAssets1(); }
    };

    const options = ["TAG Number", "Year Of Addition", "Type of Addition", "PO Number", "Supplier Name", "Invoice Number", "Asset Name", "Make", "Model Number", "Asset Serial Number", "Part Number", "TAG Name", "Nature of Presence", "Date Range"];
    const values = ["tag", "year_of_addition", "type_of_addition", "po_no", "supplier_name", "invoice_no", "asset_name", "manufacturer", "model_no", "asset_serial_no", "part_no", "tag_name", "nature_of_presence", "created_at"];
    const combinedOptions = options.map((option, index) => ({ label: option, value: values[index] }));

    const handleSelectChange = (e) => {
        const selectedOption = combinedOptions.find(opt => opt.value === e.target.value);
        setFilterCriteria(selectedOption ? selectedOption.value : '');
        setErrFilterCriteria('');
    };

    const optionsFilter = ["Contains", "Equals", "Not Contains", "Not Equals", "Blank", "Non Blank"];
    const valuesFilter = ["LIKE", "=", "NOT LIKE", "!=", "IS NULL", "IS NOT NULL"];
    const combinedOptionsFilter = optionsFilter.map((option, index) => ({ label: option, value: valuesFilter[index] }));

    const handleOperatorChange = (e) => { setFilterOperator(e.target.value); setErrFilterOperator(''); };
    const handelSearchText = (e) => { setSearchTag(e.target.value); };

    const otherDivisionOptions = otherDivisions.map(opt => ({ value: opt.id, label: opt.division_name }));
    const handleOtherDivisions = (selectedOptions) => { setSelectedOtherDivisions(selectedOptions || []); };
    const otherDivisionIds = selectedOtherDivisions.map(opt => opt.value);

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="not-allocated-list-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-slash-circle-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Not Allocated List</h5>
                        <p className="al-page-subtitle">View, search and export all unallocated assets</p>
                    </div>
                </div>
                {!loading && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill" />
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Records
                    </div>
                )}
            </div>

            {/* ══ FILTER PANEL ══ */}
            <div className="al-filter-card" id="al-filter-panel">
                <div className="al-filter-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-funnel-fill" /> Search &amp; Filter
                    </span>
                </div>
                <div className="al-filter-card-body">

                    {/* Branch selector */}
                    {otherDivisionOptions.length > 0 && (
                        <div className="al-filter-row" id="al-branch-row">
                            <label className="al-filter-label">
                                <i className="bi bi-geo-alt-fill" /> Branch (Division)
                            </label>
                            <div className="al-filter-control-full">
                                <Select
                                    options={otherDivisionOptions}
                                    isMulti
                                    placeholder="Select one or more branches…"
                                    value={selectedOtherDivisions}
                                    onChange={handleOtherDivisions}
                                    classNamePrefix="al-select"
                                />
                            </div>
                        </div>
                    )}

                    {/* Criteria / Operator / Value */}
                    <div className="al-filter-grid" id="al-filter-grid">
                        <div className="al-filter-group">
                            <label className="al-filter-label">
                                Select Criteria <span className="al-required-star">*</span>
                            </label>
                            <select className="al-form-select" value={filterCriteria} onChange={handleSelectChange}>
                                <option value="" disabled>Select Filter Criteria</option>
                                {combinedOptions.map((opt, i) => (
                                    <option key={i} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                            {ErrFilterCriteria && (
                                <span className="al-field-error">
                                    <i className="bi bi-exclamation-circle" /> {ErrFilterCriteria}
                                </span>
                            )}
                        </div>

                        {filterCriteria !== 'created_at' && (
                            <div className="al-filter-group">
                                <label className="al-filter-label">
                                    Select Operator <span className="al-required-star">*</span>
                                </label>
                                <select className="al-form-select" value={filterOperator} onChange={handleOperatorChange}>
                                    <option value="" disabled>Select Operator</option>
                                    {combinedOptionsFilter.map((opt, i) => (
                                        <option key={i} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                                {ErrFilterOperator && (
                                    <span className="al-field-error">
                                        <i className="bi bi-exclamation-circle" /> {ErrFilterOperator}
                                    </span>
                                )}
                            </div>
                        )}

                        {filterCriteria !== 'created_at' && (
                            <div className="al-filter-group al-filter-group-wide">
                                <label className="al-filter-label">
                                    Enter Criteria <span className="al-required-star">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="al-form-input"
                                    placeholder="Type search value…"
                                    value={searchTag}
                                    onChange={handelSearchText}
                                />
                                {ErrSearchTag && (
                                    <span className="al-field-error">
                                        <i className="bi bi-exclamation-circle" /> {ErrSearchTag}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Date range */}
                    {filterCriteria === 'created_at' && (
                        <div className="al-date-grid" id="al-date-grid">
                            <div className="al-filter-group">
                                <FromFieldDate
                                    label="Start Date"
                                    placeholder="Select Start Date"
                                    inputValue={startDate}
                                    setInputValue={setStartDate}
                                    setErrorMsg={ErrStartDate}
                                />
                            </div>
                            <div className="al-filter-group">
                                <FromFieldDate
                                    label="End Date"
                                    placeholder="Select End Date"
                                    inputValue={endDate}
                                    setInputValue={setEndDate}
                                    setErrorMsg={ErrEndDate}
                                />
                            </div>
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="al-filter-actions" id="al-filter-actions">
                        <button className="al-btn al-btn-primary" id="al-search-btn" onClick={handleSearch}>
                            <i className="bi bi-search" /> Search Assets
                        </button>
                        <button
                            className="al-btn al-btn-outline"
                            id="al-export-without-log-btn"
                            onClick={handleExportWithoutLog}
                            disabled={loading || exloading || exLogLoading}
                        >
                            {exloading ? (
                                <><span className="al-dot" /><span className="al-dot" /><span className="al-dot" /> Exporting…</>
                            ) : (
                                <><i className="bi bi-file-earmark-arrow-down" /> Export Data without Log</>
                            )}
                        </button>
                        <button
                            className="al-btn al-btn-primary"
                            id="al-export-with-log-btn"
                            onClick={handleExportWithLog}
                            disabled={loading || exloading || exLogLoading}
                        >
                            {exLogLoading ? (
                                <><span className="al-dot" /><span className="al-dot" /><span className="al-dot" /> Exporting…</>
                            ) : (
                                <><i className="bi bi-file-earmark-text" /> Export Data with Log</>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table" /> Not Allocated Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.sl_no}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            LoadingOverlay: CustomLoader,
                            Pagination: () => (
                                <Box className="al-pagination-bar">
                                    <div className="al-page-size-row">
                                        <span className="al-page-size-label">Rows per page</span>
                                        <Select
                                            options={[
                                                { value: 10, label: '10' },
                                                { value: 25, label: '25' },
                                                { value: 50, label: '50' },
                                                { value: 100, label: '100' },
                                                { value: 200, label: '200' },
                                                { value: 500, label: '500' },
                                            ]}
                                            value={{ value: pageSize, label: pageSize.toString() }}
                                            onChange={(sel) => handlePageSizeChange(sel.value)}
                                            classNamePrefix="al-select"
                                            menuPlacement="top"
                                            styles={{ container: (b) => ({ ...b, minWidth: 80 }) }}
                                        />
                                    </div>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        size="small"
                                    />
                                </Box>
                            ),
                        }}
                        loading={loading}
                        sx={{
                            border: 'none',
                            fontFamily: "var(--font-body)",
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#fff', fontSize: '0.75rem', fontWeight: 700,
                                textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: 'none',
                            },
                            '& .MuiDataGrid-columnHeaderTitle': { color: '#000', fontSize: '0.88rem' },
                            '& .MuiDataGrid-sortIcon': { color: 'rgb(46 45 45 / 85%)' },
                            '& .MuiDataGrid-menuIconButton': { color: 'rgb(46 45 45 / 85%)' },
                            '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': { color: 'rgba(255,255,255,0.85)' },
                            '& .MuiDataGrid-row': { fontSize: '0.8rem' },
                            '& .MuiDataGrid-row:hover': { backgroundColor: '#eef7fd' },
                            '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#d8f0fa' },
                            '& .MuiDataGrid-cell': { borderColor: '#f0f2f5' },
                            '& .MuiDataGrid-footerContainer': { borderTop: '1px solid #e2e6ef', background: '#f8f9fc' },
                            '& .MuiDataGrid-virtualScroller': { backgroundColor: '#fff' },
                        }}
                    />
                </Box>
            </div>
        </div>
    );
};

export default NonAllocated;